/**
 * Created by qingzhui on 16/12/31.
 */

require('../../scss/m/m-index.scss');

require('../../img/mobile/m-about-img1.jpg');
require('../../img/mobile/m-about-img2.jpg');
require('../../img/mobile/m-about-img3.jpg');
require('../../img/mobile/m-about-img4.jpg');
require('../../img/mobile/m-about-img5.jpg');
require('../../img/mobile/m-about-img6.jpg');
require('../../img/mobile/m-about-img7.png');
require('../../img/mobile/m-about-img8.jpg');
require('../../img/mobile/m-about-img9.jpg');

var common = require('./m-common');
var minioUrl = common.minioUrl;
var formatNoneOssUrl = require('../../fileUrl');

var $ = require('jquery');

$(function () {
    // 查看更多
    var isClick = false;

    var con1 = $('.m-business .btn-more').prev().html();

    var langInput = document.getElementById('lang');
    var lang = langInput ? langInput.value : undefined;

    var baseUrl = common.baseUrl();
    var $memberList = $('.m-leadership #list');

    // 请求的所有地址
    var ajaxUrl = {
        memberList: baseUrl + 'v1/member?lang=' + (lang === 'en' ? 'en' : 'zh')
    };

    $.ajax({
        url: ajaxUrl.memberList,
        type: 'get',
        dataType: 'json',
        data: {},
        success: function (data) {
            if (data.status) {
                // 成功进行回调
                // if(data.result.length%3==0) {
                // 	$memberList.addClass('listNew');
                // }else {
                // 	$memberList.addClass('list');
                // }
                $memberList.addClass('list');
                var htm = '';
                for (var i = 0; i < data.result.length; i++) {
                    var job = data.result[i].title;
                    var jobs = job.split(';');
                    var jobHtm = ''

                    for(var j = 0; j < jobs.length; j++){
                        jobHtm += '<h3 class="en">'+ jobs[j] + '</h3>';
                    }

                    htm += `
                    <li>
                        <img src=${formatNoneOssUrl(data.result[i].logo, minioUrl)} alt="">
                        <h3 class="cn">${data.result[i].name}</h3>
                        <div class="line"></div>
                        ${jobHtm}
                    </li>
                    `;
                }


                $memberList.empty();
                $memberList.append(htm);
            } else {
                // 错误，打印返回的数据分析情况
                console.log(data);
            }
        }
    });

    $('.btn-more').on('click', function () {
        $(this).hide();

        if (!isClick) {
            if (lang != 'en') {
                $(this).prev().html('<p>我们的核心商业准则是为客户创造价值。华兴的成功依托于客户的成功。经验告诉我们，只有持续不断地为客户创造价值，才能分享客户创造的财富。</p> <p>我们期望成为所在领域里最优秀的公司，而不一定是规模最大的公司。华兴精选合作的客户，并且只专注于那些我们可以为客户创造价值的业务领域。</p> <p>与短期的商业价值相比，我们更关注客户的质量和发展潜力。华兴从客户的创业阶段即开始提供服务，并在他们事业发展的整个过程中持续提供帮助。虽然交易金额和数量是我们衡量业绩的一个标准，但是我们的成功更多源于为优质客户提供高质量的服务，并和他们建立长久稳定的客户关系。</p> <p>我们的客户是独一无二的。华兴对每一位客户都投入大量精力，从而深刻理解每一位客户的实际需求，并为客户提供最具创新力的解决方案。</p> <p>我们是客户至上的投资银行。我们让客户放心和信赖，在任何情况下，我们都不会将自身利益置于客户利益之前。</p> <p>我们有能力充分调动华兴的资源来服务客户。我们坚信，协调充分资源为客户提供服务的能力是华兴的核心竞争力和成功的关键之一。为了让华兴更有凝聚力，我们致力于实现员工与华兴、员工与员工之间的信任和忠诚度最大化。</p> <p>我们无比重视华兴的声誉。虽然人才和资金对我们同样重要，但华兴的声誉才是我们最宝贵的资产。我们坚持以最严格的政策、法律以及道德规范来约束我们的行为。</p>');
            } else {
                $(this).prev().html('<p>Our core principle is to create value for our clients.</p> <p>Our clients’ success is our success. Experience tells us that the only way to achieve our long-term vision and goal is by consistently, reliably delivering value to our clients.</p> <p>We aim to be the best, not necessarily the biggest, in every business we operate.</p> <p>We are highly selective, both in the clients we choose to work with, and in the areas that we make our focus. We choose only the areas where we can deliver significant value to our clients.</p> <p>We choose long-term potential over short-term gains.</p> <p>China renaissance has worked with numerous early stage entrepreneurs, and supported them every step along the way as their companies grow and prosper. Although our business is measured by transactions, we place greater value on the long-term relationships that we maintain with our clients.</p> <p>Every client is unique to us.</p><p>We work hard to understand the evolving needs of each client, and strive to provide customized and innovative solutions to every client.</p> <p>We put the client first.</p> <p>Our long-term relationships are built by always putting the client’s interests above our own.</p> <p>We are One Firm. We mobilize all of our resources to help our clients.</p><p>Our willingness and commitment to help clients access all of our resources, across the firm and beyond, is the secret to our success. It is our distinguishing feature and our competitive advantage. The one firm mentality is built into our company culture. It stems from the trust, loyalty, and long-term relationships that our people have both with the firm and with each other.</p> <p>Our reputation is our greatest asset.</p><p>We uphold all government policies, laws, regulations, and the highest standard of ethics, without exception.</p>');

                $(this).hide(); // hide on click
            }
            isClick = true;
        } else {
            $(this).prev().html(con1);
            isClick = false;
        }
    });
});



// WEBPACK FOOTER //
// ./src/m/m-about.js